import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { vMaska } from 'maska'
import VueGtag from 'vue-gtag-next'

import api from './helpers/api'
window.api = api

import store from './store'

// moment as global helper
import moment from 'moment'
import 'moment/locale/pl'
window.moment = moment

let cookiesSettings = localStorage.getItem('cookies')
let enableAnalytics = false
if (cookiesSettings) {
  try {
    cookiesSettings = JSON.parse(cookiesSettings)
    enableAnalytics = !!cookiesSettings.analytics
  } catch (e) { /* noop */ }
}

const app = createApp(App)

// Plugins
app.use(router)
app.use(store)
app.use(VueDOMPurifyHTML)

// Directives (keep legacy name v-mask via alias)
app.directive('mask', vMaska)

// Conditionally enable GA4 only if user consented
if (enableAnalytics) {
  app.use(VueGtag, {
    property: {
      id: 'G-J0NXDXF3E8'
    }
  })
}

app.mount('#app')
